import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_SUBCONTRACTOR} from '../../constants';

export default {
  id: 'RDS_2',
  title: 'Come faccio a rilanciare la cartella del mio fornitore?',
  description: '',
  categories: [CONTENT_CATEGORY_SUBCONTRACTOR],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Potete chiedere al servizio Attestation Legale di rilanciare gratuitamente per voi i vostri subappaltatori quando uno o più documenti non sono aggiornati. Basta cliccare sul pulsante «Rilanciare» che si trova sulla linea del tuo fornitore.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_RDS_2/IT_RDS_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Si noti che, al di fuori dei vostri rilanci, richiediamo regolarmente i documenti quando non sono aggiornati.'
  }]
};
